export const GROUP_STATUS = {
  ACTIVE: 'ACTIVE',
  IN_PROGRESS: 'IN_PROGRESS',
  CANCELLATION: 'CANCELLATION'
}